module.exports = __webpack_public_path__ + "img/shield.d574dc40.svg";